jQuery(function ($) {
    var $w = $(window);
    var $header = $('#site-header');
    var $container = $header.find('.header-container');

    if (!$header.length || !$container.length) return;

    var activationDelta = parseInt($header.data('fixed-activation'), 10) || 100;
    var exitHoldDelta = 100;

    var ticking = false;
    var lastY = window.pageYOffset || 0;
    var prevY = lastY;

    var headerBottom = 0;
    var headerHeight = 0;

    var $spacer = $();

    function overlayActive() {
        return $header.hasClass('header-overlay');
    }

    function elemHeight($el) {
        if (!$el || !$el.length) return 0;
        var r = $el[0].getBoundingClientRect();
        return Math.max(0, Math.round(r.height || 0));
    }

    function ensureSpacer() {
        if (overlayActive()) return;
        if (!$spacer.length) {
            $spacer = $('<div class="site-header-spacer" aria-hidden="true"></div>');
            $spacer.insertAfter($header);
        }
    }

    function setSpacer(on) {
        if (overlayActive()) return;
        ensureSpacer();
        $spacer.css('height', on ? (headerHeight + 'px') : '');
    }

    function measure() {
        headerHeight = elemHeight($container);
        headerBottom = ($header.offset().top || 0) + headerHeight;
        ensureSpacer();
    }

    function teardown() {
        $header.removeClass('header-offscreen fixed exiting');
        setSpacer(false);
    }

    function update() {
        ticking = false;

        var y = lastY || 0;
        var distancePast = y - headerBottom;
        var fixedRemovalThreshold = Math.max(0, activationDelta - exitHoldDelta);
        var scrollingUp = y < prevY;

        if (distancePast >= 0) {
            if (!$header.hasClass('header-offscreen')) {
                measure();
                setSpacer(true);
                $header.addClass('header-offscreen').removeClass('exiting');
            }

            if (distancePast >= activationDelta) {
                $header.addClass('fixed').removeClass('exiting');
            } else if (scrollingUp) {
                $header.addClass('exiting');
                $header.toggleClass('fixed', distancePast >= fixedRemovalThreshold);
            } else {
                $header.removeClass('fixed exiting');
            }
        } else {
            teardown();
        }

        prevY = y;
    }

    function onScroll() {
        lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    measure();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });

    var resizeTimer;
    function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            measure();
            update();
        }, 100);
    }

    $w.on('resize orientationchange', onResize);

    $w.on('header:remeasure', function () {
        measure();
        update();
    });

    $container.on('focusin mouseenter', function () {
        if ($header.hasClass('header-offscreen') && !$header.hasClass('fixed')) {
            $header.addClass('fixed');
        }
    });
});
